import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';
import { ButtonComponent } from '../button/button.component';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-paginator',
  imports: [TranslocoDirective, ButtonComponent, SvgIconComponent, RouterLink],
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginatorComponent {
  @Input({ required: true })
  total!: number;

  @Input({ required: true })
  current!: number;
}
